import apiClient from './apiClient';
import { PACKAGE_TRANSACTION_HISTORY_URL } from './apiUrl';

const getPackageTransactionHistoryApi = id => {
  return apiClient.get(PACKAGE_TRANSACTION_HISTORY_URL + id);
};

export { getPackageTransactionHistoryApi };
